<template>
  <v-container id="users-tables" fluid tag="section">
    <base-material-card
      icon="mdi-clipboard-text"
      title="Đơn đăng ký Người lắng nghe/Tham vấn viên"
      class="px-5 py-3"
    >
      <v-data-table
        :headers="headers"
        :items="requests"
        :page.sync="page"
        :loading="loading"
        single-expand
        :expanded.sync="expanded"
        show-expand
        loading-text="Đang tải... Vui lòng chờ"
        hide-default-footer
      >
        <template v-slot:[`item.dateOfBirth`]="{ item }">
          {{ formatDate(item.dateOfBirth) }}
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
          {{ formatDate(item.createdAt) }}
        </template>
        <template v-slot:[`item.type`]="{ item }">
          {{ getType(item.type) }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <div :class="`${getStatusColor(item.status)}--text`">
            {{ getStatus(item.status) }}
          </div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            x-small
            class="green"
            :loading="loadingAccept && editId === item._id"
            :disabled="item.status === 'accepted'"
            @click="updateStatus(item, 'accepted')"
          >
            Phê duyệt
          </v-btn>
          <v-btn
            x-small
            class="red ml-2"
            :loading="loadingReject && editId === item._id"
            :disabled="item.status === 'rejected'"
            @click="updateStatus(item, 'rejected')"
          >
            Từ chối
          </v-btn>
        </template>
        <template v-slot:expanded-item="{ item }">
          <td :colspan="headers.length" class="pa-5">
            <div class="text-h4">
              Chi tiết
            </div>
            <attribute-row label="Họ và tên" :value="item.name" />
            <attribute-row label="Email" :value="item.email" />
            <attribute-row label="Điện thoại" :value="item.phone" />
            <attribute-row
              label="Ngày sinh"
              :value="formatDate(item.dateOfBirth)"
            />
            <attribute-row label="Giới tính" :value="getGender(item.gender)" />
            <attribute-row label="Địa chỉ liên hệ" :value="item.address" />
            <v-row>
              <v-col cols="2">
                <div class="text-h4">
                  Resume/CV:
                </div>
              </v-col>
              <v-col cols="3">
                <div
                  class="custom-link-button primary--text"
                  @click="download(item.resume.url, item.resume.name)"
                >
                  {{ item.resume.name }}
                </div>
              </v-col>
            </v-row>
            <hr width="500px" />
            <attribute-row label="Số CMND/CCCD/Hộ chiếu" :value="item.cmnd" />
            <v-row>
              <v-col cols="1">
                <div class="text-h4">
                  Ngày cấp:
                </div>
              </v-col>
              <v-col cols="1">
                <div>{{ formatDate(item.issueDate) }}</div>
              </v-col>
              <v-col cols="1">
                <div class="text-h4">
                  Nơi cấp:
                </div>
              </v-col>
              <v-col cols="1">
                <div>{{ item.issuePlace }}</div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="2">
                <div class="text-h4">
                  CMND/CCCD/Hộ chiếu:
                </div>
              </v-col>
              <v-col cols="3">
                <div
                  class="custom-link-button primary--text"
                  @click="download(item.cmndFile.url, item.cmndFile.name)"
                >
                  {{ item.cmndFile.name }}
                </div>
              </v-col>
            </v-row>
            <hr width="500px" />
            <div class="text-h4 font-weight-bold mt-5">
              Bằng cấp
            </div>
            <div v-for="school in item.schools" :key="school._id">
              <div class="mt-5" />
              <attribute-row
                label="Trình độ học vấn"
                :value="school.academicLevel"
              />
              <attribute-row label="Trường" :value="school.name" />
              <attribute-row
                label="Năm tốt nghiệp"
                :value="school.graduatedYear + ''"
              />
              <v-row>
                <v-col cols="2">
                  <div class="text-h4">
                    Bằng cấp:
                  </div>
                </v-col>
                <v-col cols="3">
                  <div
                    class="custom-link-button primary--text"
                    @click="download(school.degree.url, school.degree.name)"
                  >
                    {{ school.degree.name }}
                  </div>
                </v-col>
              </v-row>
            </div>
            <hr width="500px" />
            <attribute-row
              label="Số năm kinh nghiệm làm tham vấn/trị liệu tâm lý"
              :value="item.experiencedYears + ''"
            />
          </td>
        </template>
      </v-data-table>
      <v-pagination
        v-model="page"
        class="mt-5"
        :circle="false"
        :disabled="false"
        :length="totalPages"
        next-icon="navigate_next"
        prev-icon="navigate_before"
        :page="page"
        :total-visible="totalPages"
        @input="goToPage"
      />
    </base-material-card>
  </v-container>
</template>

<script>
import RegistrationApi from "@/api/RegistrationApi";
import AttributeRow from "@/components/base/AttributeRow";
import axios from "axios";

export default {
  components: {
    AttributeRow
  },
  data() {
    return {
      dialog: false,
      headers: [
        { text: "Họ và tên", value: "name" },
        { text: "Email", value: "email" },
        { text: "Ngày sinh", value: "dateOfBirth" },
        { text: "Số điện thoại", value: "phone" },
        { text: "Vị trí ứng tuyển", value: "type" },
        { text: "Thời gian tạo", value: "createdAt" },
        { text: "Trạng thái", value: "status" },
        { text: "Actions", value: "actions", sortable: false },
        { text: "", value: "data-table-expand" }
      ],
      page: 1,
      totalPages: 0,
      requests: [],
      expanded: [],
      editId: "",
      loading: true,
      loadingAccept: false,
      loadingReject: false
    };
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    getType(type) {
      return {
        listener: "Người lắng nghe",
        psychology: "Tham vấn viên"
      }[type];
    },
    getStatus(status) {
      if (!status) return "Đang chờ";
      return {
        pending: "Đang chờ",
        accepted: "Đã phê duyệt",
        rejected: "Đã từ chối"
      }[status];
    },
    getGender(gender) {
      return {
        M: "Nam",
        F: "Nữ"
      }[gender];
    },
    getStatusColor(status) {
      if (!status) return "grey";
      return {
        pending: "grey",
        accepted: "green",
        rejected: "red"
      }[status];
    },
    async loadData() {
      this.loading = true;
      const response = await RegistrationApi.getAll();
      this.loading = false;
      const { ok, data, headers } = response;
      if (ok) {
        this.requests = data;
        this.totalPages = parseInt(headers["x-total"], 10);
      }
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString("vi");
    },

    async goToPage(page) {
      this.page = page;
      this.loading = true;
      const response = await RegistrationApi.getAll(page);
      this.loading = false;
      const { ok, data } = response;
      if (ok) {
        this.requests = data;
      }
    },

    async download(url, name) {
      axios.get(url, { responseType: "blob" }).then(response => {
        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = name;
        link.click();
        URL.revokeObjectURL(link.href);
      });
    },

    async updateStatus(item, status) {
      const agree = confirm(
        "Bạn có xác nhận thay đổi trạng thái của đơn đăng ký?"
      );
      if (agree) {
        this.editId = item._id;
        if (status === "accepted") {
          this.loadingAccept = true;
        } else {
          this.loadingReject = true;
        }
        const response = await RegistrationApi.update(item._id, { status });
        const { ok, data } = response;
        this.editId = "";
        if (status === "accepted") {
          this.loadingAccept = false;
        } else {
          this.loadingReject = false;
        }
        if (ok) {
          Object.assign(this.requests[this.requests.indexOf(item)], {
            status: data.status
          });
        } else {
          alert("Cập nhật không thành công!");
        }
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.custom-link-button
  cursor: pointer
  text-decoration-line: underline
</style>
